import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Cartonization_ds_get_container_typesService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { containerTypeIds?: number[] }): 
  Promise<{ result: { Id?: number, Active?: boolean, CatchAll?: boolean, ContainerTypeCategories?: number, DimensionUomId?: number, Height?: number, InnerHeight?: number, InnerLength?: number, InnerWidth?: number, Length?: number, Name?: string, VolumeCapacity?: number, VolumeUomId?: number, Weight?: number, WeightCapacity?: number, WeightUomId?: number, Width?: number, Style?: { Id?: number, Name?: string } }[] }> 
  {
    let url = `${environment.backendUrl}api/Cartonization/datasources/ds_get_container_types/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { containerTypeIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Active?: boolean, CatchAll?: boolean, ContainerTypeCategories?: number, DimensionUomId?: number, Height?: number, InnerHeight?: number, InnerLength?: number, InnerWidth?: number, Length?: number, Name?: string, VolumeCapacity?: number, VolumeUomId?: number, Weight?: number, WeightCapacity?: number, WeightUomId?: number, Width?: number, Style?: { Id?: number, Name?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Cartonization/datasources/ds_get_container_types/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { containerTypeIds?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, Active?: boolean, CatchAll?: boolean, ContainerTypeCategories?: number, DimensionUomId?: number, Height?: number, InnerHeight?: number, InnerLength?: number, InnerWidth?: number, Length?: number, Name?: string, VolumeCapacity?: number, VolumeUomId?: number, Weight?: number, WeightCapacity?: number, WeightUomId?: number, Width?: number, Style?: { Id?: number, Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Cartonization/datasources/ds_get_container_types/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      containerTypeIds?: number[]    }) {
      return false;
    }
}
